import React from "react";
import { Lock } from "lucide-react";
import { PRODUCT_LABEL, PRODUCT_LINES } from "../../config/products";
import { useProduct } from "../../context/ProductContext";

const ProductSwitcher: React.FC = () => {
  const { product, isLocked, switchProduct } = useProduct();

  if (isLocked) {
    return (
      <div className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700">
        <Lock className="h-3.5 w-3.5 text-gray-400" />
        {PRODUCT_LABEL[product]}
      </div>
    );
  }

  return (
    <fieldset className="inline-flex rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
      <legend className="sr-only">Product</legend>
      {PRODUCT_LINES.map((line) => (
        <button
          key={line}
          type="button"
          aria-pressed={product === line}
          onClick={() => switchProduct(line)}
          className={`rounded-lg px-4 py-1.5 text-sm font-medium transition-colors ${
            product === line ? "bg-violet-600 text-white shadow-sm" : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {PRODUCT_LABEL[line]}
        </button>
      ))}
    </fieldset>
  );
};

export default ProductSwitcher;
